import { useMutation } from "@tanstack/react-query";
import type {
  FetchEndpointRequestData,
  FetchEndpointResponse,
} from "../../../schemas";
import { api } from "../api/api";

export function useFetchEndpointRequest() {
  return useMutation({
    mutationFn: ({
      projectId,
      request,
    }: {
      projectId: string;
      request: FetchEndpointRequestData;
    }): Promise<FetchEndpointResponse> => {
      return api.fetchEndpointRequest(projectId, request);
    },
  });
}
